import { useTranslation } from "react-i18next";
import AthleteIcon from "components/Icons/AthletesIcon";
import InfoCard from "components/InfoCard";
import Grid from "components/primitives/Grid";
import InfoCardControlDescriptor from "components/InfoCard/InfoCardControlDescriptor";
import Tables from "components/Tables";
import Box from "@mui/material/Box";
import Mui5 from "components/mui5";
import RagStatusIndicator from "components/RagStatusIndicator";

export interface AthleteTableInfoCardProps {
  onClose(): void;
}

function AthleteTableInfoCard(props: AthleteTableInfoCardProps) {
  const { t } = useTranslation();

  return (
    <InfoCard title={t("athlete_table_info_card.title")} icon={<AthleteIcon />} onClose={props.onClose}>
      <Grid
        container
        columns={12}
        spacing={2}
        sx={{
          width: "100%",
        }}
      >
        <Grid size={12}>
          <InfoCardControlDescriptor
            title={t("athlete_table_info_card.organise_control_title1")}
            control={
              <>
                <Tables.Icons.Filter />
                <Box sx={{ pr: 1, display: "inline-block" }} />
                <Tables.Icons.Sort />
              </>
            }
            label={t("athlete_table_info_card.organise_control_label1")}
          />
        </Grid>
        <Grid size={12}>
          <InfoCardControlDescriptor
            title={t("athlete_table_info_card.organise_control_title2")}
            control={
              <>
                <Tables.Icons.OneRepMax />
                <Box sx={{ pr: 1, display: "inline-block" }} />
                <Tables.Icons.AssignGroups />
              </>
            }
            label={t("athlete_table_info_card.organise_control_label2")}
          />
        </Grid>
        <Grid size={12}>
          <InfoCardControlDescriptor
            title={t("athlete_table_info_card.organise_control_title3")}
            control={
              <>
                <Mui5.Button color="primary" disableElevation variant="contained" size="small">
                  {t("athlete_table_info_card.organise_control_button_text3")}
                </Mui5.Button>
              </>
            }
            label={t("athlete_table_info_card.organise_control_label3")}
          />
        </Grid>
        <Grid size={12}>
          <InfoCardControlDescriptor
            title={t("athlete_table_info_card.organise_control_title4")}
            control={
              <>
                <RagStatusIndicator values={[{ variant: null, progressArrow: 1 }]} />
              </>
            }
            label={t("athlete_table_info_card.organise_control_label4")}
          />
        </Grid>
        <Grid size={12}>
          <InfoCardControlDescriptor
            title={t("athlete_table_info_card.organise_control_title5")}
            control={
              <>
                <Tables.Icons.Delete />
                <Box sx={{ pr: 1, display: "inline-block" }} />
                <Tables.Icons.Archive />
              </>
            }
            label={t("athlete_table_info_card.organise_control_label5")}
          />
        </Grid>
      </Grid>
    </InfoCard>
  );
}

export default AthleteTableInfoCard;
